const Label = ({ children, className }: { children: string, className?: string }) => {
    return (<p className={"font-poppins text-base font-bold mb-[14px] " + className}>{children}</p>);
}

export default Label;